import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

type Props = {
  label: string;
  htmlFor: string;
  error?: string;
  hint?: string;
  required?: boolean;
  children: ReactNode;
  className?: string;
};

export function FormField({ label, htmlFor, error, hint, required, children, className }: Props) {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <label htmlFor={htmlFor} className="eyebrow text-ink-muted flex items-center gap-1">
        {label}
        {required && <span className="text-accent" aria-hidden>*</span>}
      </label>
      {children}
      {hint && !error && <p className="mono-meta text-ink-muted normal-case tracking-normal">{hint}</p>}
      {error && (
        <p role="alert" className="mono-meta text-accent normal-case tracking-normal">
          {error}
        </p>
      )}
    </div>
  );
}
